var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-progress-circular',{staticClass:"ma-auto",attrs:{"width":10,"color":"primary","size":125,"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }